let Reset = {
    RESET_ALL_SETTINGS: 'RESET_ALL_SETTINGS',
};

export default Reset;
